import httpService from "./httpService";
import utils from "./utils";

export default {
    // Lấy danh sách thảo luận
    getList(usingAdvanceSearch, keyword, status, groupId, form, pageable) {
        let params = utils.merge({
            advanceSearch: usingAdvanceSearch ? true : null,
            keyword,
            status,
            groupId,
        }, pageable);
        return httpService.post("discussion/search", usingAdvanceSearch ? form : {}, { params });
    },

    // Lấy danh sách thảo luận sôi nổi
    getListTop() {
        return httpService.get("discussion/top");
    },

    // Lấy danh sách thảo luận mới
    getListNewTop() {
        return httpService.get("discussion/newTop");
    },

    // Lấy thảo luận theo id
    findById(id) {
        return httpService.get("discussion/" + id, null);
    },

    // Thêm mới thảo luận
    save(form) {
        return httpService.post(`discussion`, form);
    },

    // Sửa thảo luận
    update(id, form) {
        return httpService.put(`/discussion/${id}`, form);
    },

    // Xóa thảo luận
    delete(id) {
        return httpService.delete(`discussion/${id}`);
    },

    // Phê duyệt thảo luận
    approveDiscuss(id) {
        return httpService.get(`/discussion/approve/${id}`)
    },

    // Phê duyệt thảo luận
    declineDiscuss(id, form) {
        return httpService.put(`/discussion/decline/${id}`, form)
    },

    // Like bài thảo luận
    getComment(id, parentId, num, reported) {
        let params = { parentId, num, reported };
        return httpService.get(`/comment/${id}`, { params });
    },

    // Thêm mới bình luận
    createComment(form) {
        return httpService.post(`/comment`, form)
    },

    // Like bài thảo luận
    reactionDiscuss(id) {
        return httpService.get(`/discussion/reaction/${id}`);
    },

    // Xóa bình luận
    deleteComment(id) {
        return httpService.delete(`comment/${id}`);
    },

    // Báo cáo bình luận
    reportComment(id) {
        return httpService.get(`/comment/report/${id}`);
    },

    // Sửa bình luận
    updateComment(data) {
        return httpService.put(`/comment/${data.id}`, data)
    },

    // Lấy danh sách các nhóm thảo luận được phê duyệt
    getGroupIsAdmin() {
        return httpService.get(`/discussion/user/approve`);
    },
}



// WEBPACK FOOTER //
// ./src/views/doc-in/services/discussService.js